import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import QRCode from "react-qr-code";
import { Link } from "react-router-dom";
import DownloadAppStore from "@/assets/images/download-appstore.png";
import DownloadGooglePlay from "@/assets/images/download-googleplay.png";
import { Container, Panel, Typography } from "@/components/atoms";
import { GeneralFooter, GeneralHeader } from "@/components/organisms";
import { useAppSelector } from "@/redux/hooks";
import { activeOperatorSelector } from "@/redux/slices/operator/selectors";

export const DriverApp = () => {
  const { isAuthenticated } = useKindeAuth();
  const operator = useAppSelector(activeOperatorSelector);
  const driverAppLink = operator?.registerLinks?.driver || "https://rideminder.com/driver";

  return (
    <div className="flex min-h-screen flex-col overflow-hidden">
      <GeneralHeader action={isAuthenticated ? "logout" : undefined} />
      <div className="relative flex flex-1 flex-col">
        <Container className="relative flex w-full max-w-[600px] px-5 py-8">
          <Panel>
            <div className="flex flex-col gap-y-4">
              <Typography variant="h2">Driver Mobile App</Typography>
              <Typography variant="paragraph">
                Driver login is exclusively available on our mobile app. Download the Driver Mobile App to get started!
              </Typography>

              {/* Download Buttons */}
              <div className="flex flex-wrap gap-4">
                <Link to={driverAppLink} target="_blank" rel="noopener noreferrer">
                  <img src={DownloadAppStore} className="w-[120px]" alt="Download on the App Store" />
                </Link>
                <Link to={driverAppLink} target="_blank" rel="noopener noreferrer">
                  <img src={DownloadGooglePlay} className="w-[135px]" alt="Get it on Google Play" />
                </Link>
              </div>

              {/* QR Code */}
              <div>
                <Typography variant="paragraph" className="mb-3 text-neutral-dark-gray">
                  or scan the QR code to download
                </Typography>
                <QRCode size={120} value={driverAppLink} />
              </div>
            </div>
          </Panel>
        </Container>
      </div>
      <GeneralFooter />
    </div>
  );
};
